export const IntranetBoardingTask = {
  path: '/intranet_boarding_tasks',
  name: 'intranet_boarding_tasks',
  component: () => import('@/views/Intranet/IntranetBoardingTaskPage.vue'),
  children: [

  ],
}